import { render } from "./MonthReportView.vue?vue&type=template&id=fec064c4&ts=true"
import script from "./MonthReportView.vue?vue&type=script&lang=ts"
export * from "./MonthReportView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__